import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { zodResolver } from '@hookform/resolvers/zod'
import { Field, FieldError, FieldGroup, FieldLabel } from '~/shadcn/ui/field'
import { Form, FormField, FormItem } from '~/shadcn/ui/form/form'
import { Spinner } from '~/shadcn/ui/spinner'
import { Input } from '~/shadcn/ui/input'
import type { ForgotPasswordSchema } from './forgotPasswordSchema'
import { forgotPasswordSchema } from './forgotPasswordSchema'
import { Button } from '~/shadcn/ui/button/button'
import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'

type FormModel = ForgotPasswordSchema

type Props = {
  handleSubmitForm: (props: FormModel) => void
  isRequesting: boolean
  error: string | null
}

function ForgotPasswordForm(props: Props) {
  const form = useForm<FormModel>({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: {
      email: '',
    },
  })

  return (
    <div className="px-5 pt-10 pb-20">
      <Field className="flex flex-col items-start">
        <HeadingTwo className="font-bold mb-10">
          Obnova zabudnutého hesla
        </HeadingTwo>
      </Field>

      <Field className="flex flex-col items-start gap-15 mb-10">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(props.handleSubmitForm)}>
            <FieldGroup>
              <FormField
                control={form.control}
                name="email"
                render={({ fieldState, field }) => (
                  <FormItem>
                    <FieldLabel htmlFor="email">Váš e-mail</FieldLabel>
                    <Input
                      id="email"
                      type="text"
                      autoComplete="off"
                      aria-invalid={!!fieldState.error}
                      {...field}
                    />
                    {fieldState.error && (
                      <FieldError>{fieldState.error.message}</FieldError>
                    )}
                  </FormItem>
                )}
              />

              <Field>
                <Button
                  variant="accent"
                  type="submit"
                  disabled={props.isRequesting}
                  size="lg">
                  {props.isRequesting ? (
                    <Spinner className="size-4" />
                  ) : (
                    'Odoslať mail'
                  )}
                </Button>
              </Field>
              {form.formState.errors.root && (
                <FieldError className="text-sm font-medium text-destructive">
                  {form.formState.errors.root.message}
                </FieldError>
              )}

              {props.error != null && (
                <FieldError className="text-sm font-medium text-destructive">
                  {props.error}
                </FieldError>
              )}
            </FieldGroup>
          </form>
        </Form>

        <div className="inline-flex flex-row items-center justify-center gap-2">
          Späť na prihlásenie?{' '}
          <Link to="/login" className="text-accent">
            Prihlásenie
          </Link>
        </div>
      </Field>
    </div>
  )
}

export { ForgotPasswordForm }
